/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'
import '@ads/front-core/locales/i18n-client'
import { trackWPH, setupFetchWrapper } from '@ads/front-core/utils'
import { getScrollUpdate } from 'utils/scrollControl'
import Layout from './src/components/Layout'

export const wrapRootElement = ({ element }) => {
  return <Layout>{element}</Layout>
}

/* eslint-disable no-undef */
export const onRouteUpdate = ({ prevLocation }) => {
  trackWPH('ViewContent', {
    content_name: 'View',
  })
  if (typeof window !== 'undefined') {
    if (prevLocation) {
      if (typeof window.SavecartNS.stop === 'function') {
        window.SavecartNS.stop()
      }
    }
    if (typeof window.SavecartNS.start === 'function') {
      window.SavecartNS.start()
    }
  }
}

export const shouldUpdateScroll = () => {
  return getScrollUpdate()
}

export const onClientEntry = () => {
  setupFetchWrapper()
}
